<app-progress-indicator [inProgress]="isLoading"></app-progress-indicator>
<mat-tab-group [selectedIndex]="selectedIndex">
  <mat-tab label="Nordrhein-Westfalen">
    <app-wdr-nordrhein-westfalen-bericht [nordrheinWestfalenBericht]="wdrBericht?.nordrheinwestfalen"></app-wdr-nordrhein-westfalen-bericht>
  </mat-tab>
  <mat-tab label="Videotext">
    <app-wdr-videotext-bericht [videotextVorhersageBericht]="wdrBericht?.videotext"></app-wdr-videotext-bericht>
  </mat-tab>
  <mat-tab label="Regionen">
    <app-wdr-regionen-bericht [regionenBericht]="wdrBericht?.regionen"></app-wdr-regionen-bericht>
  </mat-tab>
  <mat-tab label="Deutschland-Nordwest">
    <app-wdr-deutschland-nordwest-bericht [deutschlandNordWestBericht]="wdrBericht?.deutschlandnordwest"></app-wdr-deutschland-nordwest-bericht>
  </mat-tab>
  <mat-tab label="Deutschland">
    <app-wdr-deutschland-bericht [deutschlandBericht]="wdrBericht?.deutschland"></app-wdr-deutschland-bericht>
  </mat-tab>
  <mat-tab label="Cosmo">
    <app-wdr-cosmo-bericht [cosmoBericht]="wdrBericht?.cosmoWetter"></app-wdr-cosmo-bericht>
  </mat-tab>
</mat-tab-group>
